var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTextBubble(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "20px",
    viewBox: "0 0 23 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30172414,19 C7.72413793,19 8.01724138,18.7738038 8.54310345,18.3040116 L11.5172414,15.6331561 L17.0517241,15.6331561 C19.6206897,15.6331561 21,14.19768 21,11.6486225 L21,4.98453359 C21,2.43547608 19.6206897,1 17.0517241,1 L5.94827586,1 C3.37931034,1 2,2.42677622 2,4.98453359 L2,11.6486225 C2,14.2063799 3.37931034,15.6331561 5.94827586,15.6331561 L6.36206897,15.6331561 L6.36206897,17.8951184 C6.36206897,18.5650072 6.69827586,19 7.30172414,19 Z",
    id: "Path",
    stroke: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4885362,5.5 C15.7707231,5.5 16,5.39130435 16,5.24782609 C16,5.10869565 15.7707231,5 15.4885362,5 L6.51146384,5 C6.2292769,5 6,5.10869565 6,5.24782609 C6,5.39130435 6.2292769,5.5 6.51146384,5.5 L15.4885362,5.5 Z",
    id: "Path",
    stroke: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4885362,8.5 C15.7707231,8.5 16,8.39224138 16,8.25 C16,8.11637931 15.7707231,8 15.4885362,8 L6.51146384,8 C6.2292769,8 6,8.11637931 6,8.25 C6,8.39224138 6.2292769,8.5 6.51146384,8.5 L15.4885362,8.5 Z",
    id: "Path",
    stroke: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4864865,11.5 C12.7747748,11.5 13,11.3922414 13,11.2543103 C13,11.112069 12.7747748,11 12.4864865,11 L6.52252252,11 C6.23423423,11 6,11.112069 6,11.2543103 C6,11.3922414 6.23423423,11.5 6.52252252,11.5 L12.4864865,11.5 Z",
    id: "Path",
    stroke: "#444444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTextBubble);
export default __webpack_public_path__ + "static/media/icon_text_bubble.ea30a6e0.svg";
export { ForwardRef as ReactComponent };